import React from 'react';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import classes from './Notification.module.css';
import { getTime,isRecentNotification } from './notificationutils';
import { setClassInfo } from '../../utils/authentication-access';
import { withTranslation } from 'react-i18next';

class NewClassNotification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			notificationtime: "Just Now",
			isNew:false
		};
	}

	componentDidMount() {
		this.setState({ notificationtime: getTime(this.props.info.createdAt) });
		this.setState({ isNew: isRecentNotification(this.props.info.createdAt) });
	}

	SelectClass = () => {
		//set Classinfo
		let info = {
			name: this.props.info.className,
			kneuraId: this.props.info.classId
		};
		setClassInfo(info);
		this.props.closeNotification();
		this.props.openClass(info);
	};

	render() {
		const { t } = this.props;
		return (
			<div className={classes.MesGrid}>
				<Grid container direction="row" justify="space-between" alignItems="flex-start" wrap="nowrap">
					<div className={ this.state.isNew ? classes.newNotificationMesHeader : classes.notificationMesHeader}>{this.props.info.instituteName}</div>
					<div className={ this.state.isNew ? classes.newNotificationDateMesHeader:classes.notificationDateMesHeader}>{this.state.notificationtime}</div>
				</Grid>
				<div className={classes.notificationMes} onClick={this.SelectClass}>
					<b>{this.props.info.instituteName}</b> {t("added you to class")} : <b>{this.props.info.className}</b>
				</div>
				<div className={this.state.isNew ? classes.NewMesDivider : classes.MesDivider} />
			</div>
		);
	}
}

export default withTranslation()(NewClassNotification);
